module.exports = __webpack_public_path__ + "img/rendering.ec80bc84.png";